export const Tabs = {
  Chats: "TABS.CHATS",
  Contacts: "TABS.CONTACTS",
  Service: "TABS.SERVICES",
  Team: "TABS.MY_TEAM",
  Settings: "TABS.SETTINGS",
} as const

export type Tab = typeof Tabs[keyof typeof Tabs]
